import { AxiosInstance } from 'axios';

import {
  UserCompetitions,
  PaginatedUserCompetitions,
  UpdateUserCompetition,
  UpdateUserCompetitionStep,
  UpdateUserCompetitionResult,
} from '../../types';
import { userCompetitionEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

class UserCompetitionApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = (competition: UserCompetitions) => {
    return this.#requestInstance
      .post(userCompetitionEndpoints.userCompetition, { ...competition, createdAt: new Date() })
      .then(({ data }) => data);
  };

  deleteUserCompetition = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(
      userCompetitionEndpoints.deleteUpdateUserCompetitionById(id)
    );
  };

  getUserCompetitions = async (competition: {
    id: number;
    order?: string;
  }): Promise<PaginatedUserCompetitions> => {
    return this.#requestInstance.get(
      userCompetitionEndpoints.getUserCompetitionById(competition.id, competition.order)
    );
  };

  updateUserCompetition = async (competitionDto: UpdateUserCompetition): Promise<void> => {
    return this.#requestInstance.patch(
      userCompetitionEndpoints.deleteUpdateUserCompetitionById(competitionDto.id),
      {
        name: competitionDto.name,
        description: competitionDto.description,
        bet: competitionDto.bet,
        participantId: competitionDto.participantId,
      }
    );
  };

  updateUserCompetitionStepById = async (
    competitionDto: UpdateUserCompetitionStep
  ): Promise<void> => {
    return this.#requestInstance.patch(
      userCompetitionEndpoints.updateUserCompetitionStepById(competitionDto.id),
      {
        step: competitionDto.competitionStep,
        participantId: competitionDto.participant,
      }
    );
  };

  updateUserCompetitionResults = async (
    competitionDto: UpdateUserCompetitionResult
  ): Promise<void> => {
    return this.#requestInstance.patch(
      userCompetitionEndpoints.updateUserCompetitionResultById(competitionDto.id),
      {
        initiatorId: competitionDto.initiator,
        winnerId: competitionDto.winnerId,
        status: competitionDto.competitionStep,
      }
    );
  };
}

export const userCompetitionsApi = new UserCompetitionApi(axios);
